function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.8333 6.51816C15.8333 9.27536 13.9949 11.2682 12 11.2682C10.0051 11.2682 8.16667 9.27536 8.16667 6.51816C8.16667 3.76096 10.0051 1.76816 12 1.76816C13.9949 1.76816 15.8333 3.76096 15.8333 6.51816Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.77702 21.8689C2.02027 18.5045 3.88714 15.5895 6.6007 13.9045C8.0111 15.4562 9.89686 16.4348 12 16.4348C14.1031 16.4348 15.9889 15.4562 17.3993 13.9045C20.1129 15.5895 21.9797 18.5045 22.223 21.8689H1.77702Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgUser = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/User.ed7611a6.svg";
export { ForwardRef as ReactComponent };